import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Elements } from '@stripe/react-stripe-js'
import StripeWidgets from './components/StripeWidgets'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import type { Stripe, StripeElementsOptionsMode } from '@stripe/stripe-js'
import getStripeInstance, { type StripeInstanceResult } from 'lib/payment/getStripeInstance'
import { STRIPE_ELEMENTS_APPEARANCE } from 'lib/payment/stripeUtils'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { useStripeElementsLocale } from 'hooks/useStripeElementsLocale'

const RelativeContainer = styled.div`
  position: relative;
`

interface State {
  stripe?: Stripe | null
  chargeDescriptors?: any
}

interface Props extends MappedProps {
  regionCode: string
  currencyCode: string
  purpose: string
  purposeId: string
  onSuccess?: () => void
  onFailure?: () => void
}

type MappedProps = Pick<Props, 'regionCode' | 'currencyCode'>

export function StripeOffsessionCardUpdate(props: Props) {
  const intl = useIntl()
  const stripeLocale = useStripeElementsLocale()
  const { currencyCode, regionCode, purposeId, purpose, onSuccess, onFailure } = props
  const [state, setState] = useState({} as State)
  useEffect(() => {
    getStripeInstance(currencyCode).then((result: StripeInstanceResult) => {
      setState({
        stripe: result.stripe,
        chargeDescriptors: result.charge_descriptors,
      })
    })
  }, [currencyCode])

  const { stripe, chargeDescriptors } = state

  const StripePaymentElementOptions: StripeElementsOptionsMode = {
    mode: 'setup',
    paymentMethodCreation: 'manual',
    currency: currencyCode.toLowerCase(),
    paymentMethodTypes: ['card'],
    appearance: STRIPE_ELEMENTS_APPEARANCE,
    locale: stripeLocale,
  }

  const loadingText = intl.formatMessage({
    id: 'pybYOIIlZ5bXLedXatUf',
    defaultMessage: 'Loading...',
    description: 'Loading indicator text with ellipsis shown while content is being fetched',
  })

  return (
    <RelativeContainer>
      {stripe &&
        <Elements stripe={stripe} options={StripePaymentElementOptions}>
          <StripeWidgets
            currencyCode={currencyCode}
            regionCode={regionCode}
            chargeDescriptors={chargeDescriptors}
            stripe={stripe}
            purpose={purpose}
            purposeId={purposeId}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />
        </Elements>}
      <LoadingIndicator floating visible={!stripe}>{loadingText}</LoadingIndicator>
    </RelativeContainer>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    regionCode: state.geo.currentRegionCode,
    currencyCode: state.geo.currentCurrency,
  }
}

export default connect(mapStateToProps)(StripeOffsessionCardUpdate)
